// @flow weak

import React from 'react';
import _ from 'lodash';

const defaultMergeProps = (partialProps, props) => ({
  ...partialProps,
  ...props,
});

const createRenderCallbackWith = (
  mergeProps,
  Component,
  partialProps
) => props => <Component {...mergeProps(partialProps, props)} />;

const createRenderCallback = _.partial(
  createRenderCallbackWith,
  defaultMergeProps
);

export default createRenderCallback;
